"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = require("react");

const DialogProvider_1 = require("../providers/DialogProvider");
/**
 * @deprecated The useDialog hook has been deprecated and will be removed in a
 * future breaking change. Instead, you can simply render an Overlay component
 * and place a Dialog (or any other component) inside.
 */


const useDialog = () => react_1.useContext(DialogProvider_1.DialogContext);

exports.default = useDialog;